import React from 'react';

import { useIntl } from '../../util/reactIntl';
import franceFlagImage from '../../assets/france flag.jpg';
import css from './TrustBanner.module.css';

const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const PaymentIcon = props => (
  <svg {...iconProps} {...props}>
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const SupportIcon = props => (
  <svg {...iconProps} {...props}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
  </svg>
);

const ExchangeIcon = props => (
  <svg {...iconProps} {...props}>
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 014-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 01-4 4H3" />
  </svg>
);

const WarrantyIcon = props => (
  <svg {...iconProps} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const ITEMS = [
  { Icon: PaymentIcon, labelId: 'TrustBanner.paymentLabel', subId: 'TrustBanner.paymentSub' },
  { Icon: SupportIcon, labelId: 'TrustBanner.supportLabel', subId: 'TrustBanner.supportSub' },
  { Icon: ExchangeIcon, labelId: 'TrustBanner.exchangeLabel', subId: 'TrustBanner.exchangeSub' },
  { Icon: WarrantyIcon, labelId: 'TrustBanner.warrantyLabel', subId: 'TrustBanner.warrantySub' },
];

const TrustBanner = () => {
  const intl = useIntl();

  return (
    <section className={css.trustBanner} aria-labelledby="trust-banner-heading">
      <div className={css.trustBannerInner}>
        <h2 id="trust-banner-heading" className={css.trustTitle}>
          {intl.formatMessage({ id: 'TrustBanner.title' })}
        </h2>
        <p className={css.trustLead}>{intl.formatMessage({ id: 'TrustBanner.lead' })}</p>
        <ul className={css.trustItems}>
          {ITEMS.map(({ Icon, labelId, subId }) => (
            <li key={labelId} className={css.trustItem}>
              <span className={css.trustIconBadge}>
                <Icon className={css.trustIcon} />
              </span>
              <span className={css.trustLabel}>{intl.formatMessage({ id: labelId })}</span>
              <span className={css.trustSub}>{intl.formatMessage({ id: subId })}</span>
            </li>
          ))}
        </ul>
        <div className={css.flagWrap} aria-hidden="true">
          <img className={css.flagImage} src={franceFlagImage} alt="" />
          <span className={css.flagOverlay} />
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
